import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Mail, MapPin } from 'lucide-react';
export function GetInvolvedPage() {
  return <div className="min-h-screen bg-warmgray font-sans text-navy selection:bg-red selection:text-white" data-id="element-392">
      <Navbar alwaysSolid data-id="element-393" />

      {/* Hero Section with Background Image */}
      <section className="relative pt-32 pb-24 md:pt-48 md:pb-32 flex items-center justify-center overflow-hidden" data-id="element-394">
        <div className="absolute inset-0 z-0" data-id="element-395">
          <img src="https://cdn.magicpatterns.com/uploads/vWZZYsZpHHZ6EnuE5Pnmee/EG_homepage-edit.jpg" alt="Elizabeth Guzmán with community members" className="w-full h-full object-cover object-top" data-id="element-396" />
          <div className="absolute inset-0 bg-navy/40 mix-blend-multiply" data-id="element-397"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-navy/50 via-navy/30 to-warmgray" data-id="element-398"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-399">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-400">
            <span className="inline-block bg-red text-white font-bold tracking-widest uppercase text-xs px-5 py-2 rounded-sm mb-6" data-id="element-401">
              Elizabeth Needs You On Her Team
            </span>
            <h1 className="text-5xl md:text-7xl font-serif text-white mb-6 leading-tight drop-shadow-lg" data-id="element-402">
              Join the <span className="italic text-sky" data-id="element-403">Movement</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 font-light leading-relaxed max-w-2xl mx-auto drop-shadow-md" data-id="element-404">
              This is a grassroots campaign powered by working people. Whether
              you can knock on a few doors, make phone calls, or host a
              neighborhood event — every action brings us closer to victory.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Embedded Google Form Section */}
      <main className="relative z-20 -mt-12 pb-24 px-6" data-id="element-405">
        <div className="max-w-4xl mx-auto" data-id="element-406">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white rounded-sm shadow-2xl border-t-4 border-red overflow-hidden" data-id="element-407">
            <div className="text-center pt-8 md:pt-12 px-8 md:px-12 mb-6" data-id="element-408">
              <h2 className="text-3xl font-serif text-navy mb-3" data-id="element-409">
                How would you like to be involved?
              </h2>
              <p className="text-navy/60 font-light" data-id="element-410">
                Fill out the form below, and we'll connect you with our
                volunteer team.
              </p>
            </div>

            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScPfRHO_J6qXBR7jWw8ZBqfe9EqwJCDeQaWW21m8av_jS1GjQ/viewform?embedded=true" width="100%" height="1200" frameBorder="0" marginHeight={0} marginWidth={0} title="Volunteer Sign Up Form" className="w-full" data-id="element-411">
              Loading…
            </iframe>
          </motion.div>
        </div>
      </main>

      {/* Horizontal Contact Strip */}
      <section className="bg-navy py-12 border-t border-white/10" data-id="element-412">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-413">
          <h3 className="text-white font-serif text-2xl mb-8" data-id="element-414">
            Have questions for our volunteer team?
          </h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16" data-id="element-415">
            <div className="flex items-center gap-3 text-white/80" data-id="element-416">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0" data-id="element-417">
                <Mail size={18} className="text-sky" data-id="element-418" />
              </div>
              <a href="mailto:info@guzmanforvirginia.com" className="hover:text-white transition-colors" data-id="element-419">
                info@guzmanforvirginia.com
              </a>
            </div>
            <div className="hidden md:block w-[1px] h-12 bg-white/20" data-id="element-420"></div>
            <div className="flex items-center gap-3 text-white/80 text-left" data-id="element-421">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0" data-id="element-422">
                <MapPin size={18} className="text-sky" data-id="element-423" />
              </div>
              <div data-id="element-424">
                <p data-id="element-425">P.O. Box 74</p>
                <p data-id="element-426">Nokesville, VA 20182</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-427" />
    </div>;
}